import React from 'react';

export const CenterContext = React.createContext<{center: any}>({
center: null,
});
